import { Singleton } from './singleton-factory';

const overriddenSingletons = new Set<Singleton<unknown>>();

export const singletonTestingUtils = {
	override<T, TFake extends T>(singleton: Singleton<T>, instance: TFake): TFake {
		singleton.reset();
		singleton.override(instance);
		overriddenSingletons.add(singleton as Singleton<unknown>);
		return instance;
	},

	reset(): void {
		overriddenSingletons.forEach((s) => s.reset());
		overriddenSingletons.clear();
	},
};
